import FlexContainer from 'components/common/FlexContainer';
import styled from '@emotion/styled';

export const FullPageContainer = styled(FlexContainer)({
  height: '100vh',
  width: '100vw',
});
